import { actionTypes } from '../actions';

const initialState = {
  url: '',
};

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case actionTypes.SET_URL:
      return {
        ...state,
        url: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/url.js